import axios from "axios";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { IMAGE_URL, USER_ID, ERPUrl, USER_LOCAL_ID } from "../constants";
import { scAxios, scAxiosAdmin, thirdparty } from "..";

// Your component code here

const SwiperComponent = () => {
  const id = localStorage.getItem(USER_LOCAL_ID);
  const [data, setData] = useState([]);
  const [prescriptionData, setPrescriptionData] = useState([]);
  const [Recentdata, setRecentData] = useState([]);
  const [erpData, setEerpData] = useState([]);
  const [additionalData, setAdditionalData] = useState([]);
  const [upComingAppointments, setUpComingAppointments] = useState([]);
  const [recentAppointments, setRecentAppointments] = useState([]);
  console.log(Recentdata);
  // console.log(data, "info")
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await scAxiosAdmin.get(
          `/my_appointments/${localStorage.getItem(USER_LOCAL_ID)}`,

          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        setPrescriptionData(response.data.data); // Assuming the response contains the data you need
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await thirdparty(
          `/appointments/upcoming?patient_id=${id}&status=Confirmed`
        );

        setData(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await thirdparty(
          `/appointments/recent?patient_id=${id}&status=Completed`
        );

        setRecentData(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await scAxios(
          // `/appointments/recent?patient_id=${id}&status=Completed`
          `/patients?patient=${id}`
        );
        if (response.status === 200) {
          setEerpData(response.data[0].latest_consultant);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchAppointmentData = async () => {
      const updatedData = [];

      for (const appointment of erpData) {
        const doctorData = await fetchData(appointment.doctor);
        updatedData.push({ ...appointment, doctorData });
      }

      setAdditionalData(updatedData);
    };

    fetchAppointmentData();
  }, [erpData]);
  const fetchData = async (doctorId) => {
    try {
      const response = await scAxiosAdmin(
        `/doctors/get_doctor_by_uhlid?uhl_id=${doctorId}`
      );

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div>
      {/* <Swiper className="mySwiper shadow-lg mb-2 mt-2">
        {prescriptionData &&
          prescriptionData.map((appointment) => {
            if (
              appointment.status === "Booked" ||
              appointment.status === "Confirmed"
            ) {
              return (
                <SwiperSlide key={appointment.id}>
                  <div className="card">
                    <div className="card-body" style={{ padding: "1rem" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6>Upcoming Appointment</h6>
                        <span
                          className={`badge bg-${
                            appointment.status === "Confirmed"
                              ? "success"
                              : "warning"
                          }`}
                        >
                          {appointment.status}
                        </span>
                      </div>

                      <div className="row">
                        <div className="col-5 d-flex justify-content-between align-items-center">
                          <h6>{appointment.date}</h6>
                          <img
                            src={
                              IMAGE_URL +
                              "DoctorProfileImg/" +
                              appointment.doctorData.data.doctor_profile
                            }
                            width={71}
                            height={71}
                            style={{ borderRadius: "50%", objectFit: "cover" }}
                            alt="avtars"
                          />
                        </div>
                        <div className="col-7">
                          <h5
                            style={{
                              fontSize: "16px",
                              color: "#55A5A6",
                              fontWeight: "bold",
                            }}
                          >
                            {appointment.doctor_detail.name}
                          </h5>
                          <h5 style={{ fontSize: "12px", fontWeight: 400 }}>
                            {
                              appointment.doctorData.data.department_mave
                                .department_name
                            }
                          </h5>
                          <h5 style={{ fontSize: "12px", fontWeight: 400 }}>
                            {" "}
                            <span style={{ fontWeight: 600 }}>
                              Degree :
                            </span>{" "}
                            {appointment.doctorData.data.degree}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            }
          })}
      </Swiper> */}
      <Swiper className="mySwiper shadow-lg mb-2 mt-2 ">
        {prescriptionData &&
          prescriptionData.map((recentAppointment, index) => {
            if (recentAppointment.doctor_mave) {
              return (
                <SwiperSlide
                  key={recentAppointment.id}
                  style={{ cursor: "grab" }}
                >
                  <div className="card">
                    <div className="card-body" style={{ padding: "1rem" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex flex-column justify-content-start mb-3">
                          <h6>Recent Appointments</h6>
                          {recentAppointment.appointment_date ? (
                            <small class="text-muted">
                              Appointment Date:{" "}
                              {recentAppointment.appointment_date}
                            </small>
                          ) : (
                            ""
                          )}
                          {recentAppointment.appointment_time ? (
                            <small class="text-muted">
                              Appointment Time:{" "}
                              {recentAppointment.appointment_time}
                            </small>
                          ) : (
                            ""
                          )}
                        </div>
                        {/* <span
                          className={`badge bg-${
                            recentAppointment.status === "Confirmed"
                              ? "success"
                              : "warning"
                          }`}
                        >
                          {recentAppointment.status}
                        </span> */}
                      </div>
                      <div className="row">
                        <div className="col-5 d-flex justify-content-between align-items-center ">
                          {recentAppointment.doctor_mave.doctor_profile ? (
                            <img
                              src={
                                IMAGE_URL +
                                "DoctorProfileImg/" +
                                recentAppointment.doctor_mave.doctor_profile
                              }
                              style={{
                                width: "71px",
                                height: "71px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                              alt="avtars"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-7">
                          <h5
                            style={{
                              fontSize: "16px",
                              color: "#55A5A6",
                              fontWeight: "bold",
                            }}
                          >
                            {recentAppointment.doctor_name}
                          </h5>
                          <h5 style={{ fontSize: "12px", fontWeight: 400 }}>
                            {recentAppointment.doctor_mave.departments_mave.map(
                              (dept, index) => {
                                return (
                                  dept.department_name +
                                  `${
                                    recentAppointment.doctor_mave
                                      .departments_mave.length > index
                                      ? ","
                                      : ""
                                  }`
                                );
                              }
                            )}
                          </h5>
                          <h5 style={{ fontSize: "12px", fontWeight: 400 }}>
                            {" "}
                            <span style={{ fontWeight: 600 }}>
                              Degree :
                            </span>{" "}
                            {recentAppointment.doctor_mave.degree}
                          </h5>
                        </div>
                      </div>
                      {/* <div className="mt-3">
                        <ul
                          className="nav nav-pills mb-3 d-flex tabsGroup"
                          id="pills-tab"
                          role="tablist"
                        >
                          <li
                            className="nav-item flex-grow-1"
                            role="presentation"
                          >
                            <button
                              className="w-100 btn btn-sm tip1"
                              id="pills-report-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-report"
                              type="button"
                              role="tab"
                              aria-controls="pills-report"
                              aria-selected="true"
                            >
                              Prescription
                            </button>
                          </li>
                          <li
                            className="nav-item flex-grow-1"
                            role="presentation"
                          >
                            <button
                              className="w-100 btn btn-sm tip2"
                              id="pills-prescription-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-prescription"
                              type="button"
                              role="tab"
                              aria-controls="pills-prescription"
                              aria-selected="false"
                            >
                              Investigation
                            </button>
                          </li>
                          <li
                            className="nav-item flex-grow-1"
                            role="presentation"
                          >
                            <button
                              className="w-100 btn btn-sm tip3"
                              id="pills-medicine-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-medicine"
                              type="button"
                              role="tab"
                              aria-controls="pills-medicine"
                              aria-selected="false"
                            >
                              Medicine
                            </button>
                          </li>
                        </ul>
                        <div
                          className="tab-content"
                          id={`pills-tabContent-${index}`}
                        >
                          <div
                            className="tab-pane fade show active"
                            id="pills-report"
                            role="tabpanel"
                            aria-labelledby="pills-report-tab"
                          >
                            One
                          </div>
                          <div
                            className="tab-pane fade"
                            id="pills-prescription"
                            role="tabpanel"
                            aria-labelledby="pills-prescription-tab"
                          >
                            Two
                          </div>
                          <div
                            className="tab-pane fade"
                            id="pills-medicine"
                            role="tabpanel"
                            aria-labelledby="pills-medicine-tab"
                          >
                            Three
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </SwiperSlide>
              );
            } else {
              return (
                index === 0 && (
                  <SwiperSlide key={recentAppointment.id}>
                    <div className="card">
                      <div className="card-body" style={{ padding: "1rem" }}>
                        <h6>Recent Appointments</h6>
                        <h5>No Recent Appointments</h5>
                      </div>
                    </div>
                  </SwiperSlide>
                )
              );
            }
          })}
      </Swiper>
      {/* <div className="btn-group w-100" role="group" aria-label="Basic example">
        <a className="btn btn-sm tip1">Report</a>
        <a className="btn btn-sm tip2">Prescription</a>
        <a className="btn btn-sm tip3">Medicine</a>
      </div> */}
    </div>
  );
};

export default SwiperComponent;



// WEBPACK FOOTER //
// ./src/component/SwiperComponent.js